import React, { Component } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default class EventosExcel extends Component {
  exportarExcel = async () => {
    
  const anio = this.props.anio;

  if (!anio || isNaN(anio) || ! anio > 2000 ) {
    alert('Seleccione un año antes de generar la descarga');
    return; // detiene el proceso
  }
    const eventos = this.props.data;
    const workbook = new ExcelJS.Workbook();
    const ws = workbook.addWorksheet('Calendario');

    const hoy = new Date();
    const diasEnMes = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // console.log("anio ", anio)
// console.log("eventos ", eventos)

    const tipoColorMap = {
    "MISION TECNOLOGI": "A9C1D9",
    "MISION TECNOLOGICA": "A9C1D9",
    "MISION TECNOLÓGICA": "A9C1D9",
    "ENCUENTRO EMPRESA": "B7E4C7",
    "FERIA COMERCIAL": "FFF3B0",
    "FERIA INTERNACION": "D8C4EF",
    "FERIA INTERNACIONAL": "D8C4EF",
    "MISION COMERCIAL": "FFD6D9",
    "OTRO": "E6E6E6",
    "OTROS": "E6E6E6",
    "RUEDA DE NEGOCIOS": "CFE8F3",
    "SHOWROOM": "F3D1F4",
  };

    // Título en A1
  const diaNumero = hoy.getDate();
  const mesNombre = hoy.toLocaleDateString('es-PE', { month: 'long' });
  const anioHoy = hoy.getFullYear();

  const fechaLarga = `${diaNumero} de ${mesNombre} del ${anioHoy}`;
    ws.mergeCells('A1:AG1');
    ws.getCell('A1').value = `Exportemos.pe - Calendario ${anio} (al ${fechaLarga})`;
    ws.getCell('A1').alignment = { horizontal: 'center' };
    ws.getCell('A1').font = { size: 14, bold: true };

    // Cabecera en fila 3
    const header = ['NRO', 'NOMBRE DE EVENTO'];
    for (let d = 1; d <= 31; d++) header.push(d);
    ws.getRow(3).values = header;
    ws.getRow(3).font = { bold: true };
    // ws.getRow(3).alignment = { horizontal: 'center' };

    // Column widths
    ws.getColumn(1).width = 6;   // NRO
    ws.getColumn(2).width = 60;  // EVENTO
    for (let c = 3; c <= 33; c++) {
      ws.getColumn(c).width = 3.5;
    }

    // Inicio de filas
    let filaActual = 4;
    let secuenciaGlobal = 1;

    for (let mes = 0; mes < 12; mes++) {

// console.log("step x mes ", mes)

      const nombreMes = new Date(anio, mes).toLocaleString('es-PE', { month: 'long' }).toUpperCase();

      // Fila del mes: solo en columna B
      const filaMes = ws.getRow(filaActual);
      filaMes.getCell(2).value = nombreMes;
      filaMes.getCell(2).font = { bold: true };
      ws.mergeCells(`B${filaActual}:AG${filaActual}`);
      filaActual++;

      // Filtrar eventos del mes
      const eventosMes = eventos.filter(ev => {
        const ini = new Date(ev.even_FechaInicio);
        const fin = new Date(ev.even_FechaFin);
        return ini.getMonth() == mes //&& fin.getMonth() >= mes
        ;
      });

      // if (eventosMes.length >0 )
      // console.log("eventosMes: " , eventosMes)

      for (const evento of eventosMes) {
        const rowData = [];
        rowData[0] = secuenciaGlobal++;
        rowData[1] = `\t${evento.even_Tipo.trim().toUpperCase()}: ${evento.even_Titulo}`;
// console.log("Loop eventosMes x mes :: titulo: " , rowData[1])

        for (let i = 1; i <= 31; i++) rowData.push('');
          const ini = new Date(evento.even_FechaInicio);
          const fin = new Date(evento.even_FechaFin);
          const tipo = (evento.even_Tipo || '').trim().toUpperCase();
          const color = tipoColorMap[tipo] || 'F0F0F0';

          for (let dia = 1; dia <= diasEnMes[mes]; dia++) {
            const fechaDia = new Date(anio, mes, dia);
            if (fechaDia >= ini && fechaDia <= fin) {
              rowData[1 + dia] = '●'; // antes:●
            }
        }

        const row = ws.addRow(rowData);
        row.eachCell((cell, col) => {
          if (typeof cell.value === 'string' && cell.value ==='●') { //●
             cell.value = ''; 
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: color }
            };
          }
        });

        filaActual++;
      }

    }

    // Borde a todo
    ws.eachRow({ includeEmpty: false }, row => {
      row.eachCell(cell => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    //Leyenda: solo tipos presentes en la consulta
    const tiposUsados = Array.from( new Set(this.props.data.map(e => (e.even_Tipo || '').trim().toUpperCase())) ).filter(Boolean);
    ws.addRow([]);
    ws.addRow([]);
    const leyendaTituloRow = ws.addRow([null, 'Leyenda']);
    leyendaTituloRow.getCell(2).font = { bold: true };

    tiposUsados.forEach((tipo) => {
    const color = tipoColorMap[tipo] || 'F0F0F0';
    const row = ws.addRow([null, `  ${tipo}`]);

    const cell = row.getCell(2);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: color }
    };
    cell.font = {
      color: { argb: '000000' },
      bold: true
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' }
    };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Exportemos-CalendarioEventos-${anio}.xlsx`);
  };

  formatDate = (fechaStr) => {
    const fecha = new Date(fechaStr);
    return fecha.toLocaleDateString('es-PE', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).toUpperCase();
  };

  capitalizar = (texto) => {
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
};

  render() {
    return null; 
  }
}
